var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"center-img",attrs:{"width":"100","height":"100","src":require("../assets/img/wallet-bg.png"),"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }